module.exports = __webpack_public_path__ + "static/media/avcLandingBg.345e949f.svg";